<div class="hmn-padding__x4-horiz hmn-row__align">
  <app-shared-vert-bar></app-shared-vert-bar>

  <div class="hmn-margin__x2-left hmn-padding__x2-horiz hmn-cursor__pointer">
    <p class="hmn-color__primary">home</p>
  </div>

  <div class="hmn-padding__x2-horiz hmn-cursor__pointer hmn-toolbar-navigation__selected">
    <p class="hmn-color__primary">units</p>
  </div>

  <div class="hmn-padding__x2-horiz hmn-cursor__pointer">
    <p class="hmn-color__primary">bookings</p>
  </div>

  <div class="hmn-padding__x2-horiz hmn-cursor__pointer">
    <p class="hmn-color__primary">calls</p>
  </div>
</div>
